import { useEffect } from 'react'
import ReactGA from 'react-ga4'

export default function useGaPageView(name: string) {
  useEffect(() => {
    if (process.env.REACT_APP_GA_ENABLED === 'true' && process.env.REACT_APP_GA_TRACKING_ID) {
      ReactGA.send({ hitType: 'pageview', page_title: name, page_location: window.location.pathname })
    }
  }, [])
}